import { httpClient, resolveApiUrl } from '#shared/api'
import GetFaqResponse from '../model/get-faq-response'

export default async function getFaq(role: 'client' | 'staff') {
  const response = await httpClient.get<GetFaqResponse>('users/info/faq/' + role, {
    prefixUrl: resolveApiUrl('@sd-users'),
  })

  const parsedResponse = await response.json()
  return parsedResponse
}
